import { useQuery } from '@tanstack/react-query';
import { api, type Envelope } from '@/lib/apiClient';
import type { OrderDTO } from '@/types/api';

async function fetchOrder(id: number): Promise<OrderDTO> {
  const res = await api.get<Envelope<OrderDTO>>(`/api/v1/orders/${id}`);
  return res.data.data;
}

export function useOrder(id: number | null) {
  return useQuery({
    queryKey: ['order', id],
    queryFn: () => fetchOrder(id as number),
    enabled: id != null,
    staleTime: 5_000,
  });
}
